// leaseViewPath — the SPA path of the staff "view a lease" page (/leases/:groupId).
// Dependency-free on purpose: the entry points (Full Details, Sent Items panel,
// lease builder) import it without pulling in any client module.

export function leaseViewPath(groupId: string, versionId?: string | null): string {
  const base = `/leases/${encodeURIComponent(groupId)}`;
  return versionId ? `${base}?version=${encodeURIComponent(versionId)}` : base;
}
